import React, {Component} from 'react';
import { Toast, Modal } from 'antd-mobile';
import Blank from '../components/Blank';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import TipPlaceholder from '../components/TipPlaceholder';
import HeaderView from '../components/HeaderView';
import ProfileView from '../components/ProfileView';
import RechargeView from '../components/RechargeView';
import PacketView from '../components/PacketView';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import BrandUtils from '../utils/BrandUtils';
import Constants from '../utils/Constants';
import { createForm } from 'rc-form';
import '../styles/User.css';

const alert = Modal.alert

class User extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: 'loading',
            latestDevice: null,
            deviceInfo: {},
            userProfile: {},
            rechargeRules: [],
            packetRules: [],
            enableRecharge: true,
            enableBuyPacket: true,
            enableContinuing: true,
            brandInfo: null,
            deviceTypes: []
        }
    }

    componentDidMount() {
        this.loadInitData()
    }

    loadInitData = () => {
        this.loadLatestDevice(() => {
            this.loadDeviceTypes()
            this.loadBranInfo()
            this.loadDeviceInfo()
            this.loadProfile()
            this.loadRechargeRules()
            this.loadPacketRules()
        })
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadBranInfo = () => {
        DataFetcher.brandInfo({
        }, {
            success: (resp) => {
                this.setState({
                    brandInfo: resp.data
                }, () => {
                    BrandUtils.refreshPageBrand(this.state.brandInfo)
                })
            }
        })
    }

    loadLatestDevice = (callback) => {
        DataFetcher.latestDevice({
            success: (resp) => {
                this.setState({
                    latestDevice: resp.data
                }, () => {
                    callback&&callback()
                })
            }
        })
    }

    loadDeviceInfo = () => {
        const { latestDevice } = this.state
        if(CommonUtils.isEmpty(latestDevice)) return

        DataFetcher.deviceInfo(latestDevice, (resp) => {
            this.setState({
                deviceInfo: resp.data
            })
        })
    }

    loadProfile = () => {
        const { latestDevice } = this.state
        DataFetcher.profile({
            deviceId: latestDevice
        }, { 
            success: (resp) => {
                this.setState({
                    status: 'success',
                    userProfile: resp.data
                })
            }
        })
    }

    loadPacketRules = () => {
        const { latestDevice } = this.state
        if(CommonUtils.isEmpty(latestDevice)) {
            return
        }

        DataFetcher.packetRules({
            deviceId: latestDevice
        },{
            success: (resp) => {
                this.setState({
                    packetRules: resp.data
                })
            }
        })
    }

    loadRechargeRules = () => {
        const { latestDevice } = this.state
        DataFetcher.rechargeRules({
            deviceId: latestDevice
        }, (resp) => {
            this.setState({
                rechargeRules: resp.data
            })
        })
    }

    handleContinuing = () => {
        const { latestDevice } = this.state
        if(CommonUtils.isEmpty(latestDevice)) {
            return
        }

        this.setState({
            enableContinuing: false
        })
        DataFetcher.loginDevice({
            deviceId: latestDevice
        }, (resp) => {
            Toast.info('设备启动中！若无响应，可使用其它设备！', 5)
        }, () => {
            this.setState({
                enableContinuing: true
            })
        })
    }

    canPayUsingBalance = (packetRule) => {
        const { userProfile } = this.state
        if(!packetRule || !userProfile || !userProfile.balance || userProfile.balance <= 0) {
            return false
        }

        if(userProfile.fresher && packetRule.fresherPrice && packetRule.fresherPrice > 0) {
            if(userProfile.balance >= packetRule.fresherPrice) {
                return true
            } else {
                return false
            }
        }

        return userProfile.balance >= packetRule.price
    }

    calExchangeGameMinutes = () => {
        const { userProfile, packetRules } = this.state
        if(!userProfile || !userProfile.balance || userProfile.balance <= 0) {
            return 0
        }

        if(!packetRules || !packetRules.length) {
            return 0
        }

        let targetGameMinutes = 0
        let targetPrice = 0
        for(let rule of packetRules) {
            if(targetPrice <= 0 || rule.price < targetPrice) {
                targetGameMinutes = rule.gameMinutes
                targetPrice = rule.price
            }
        }

        if(targetPrice <= 0) {
            return 0
        }

        let gameMinutes = Math.ceil(userProfile.balance/targetPrice*targetGameMinutes)
        if(gameMinutes <= 0) {
            gameMinutes = 1
        }
        return gameMinutes
    }

    handleBuyPacket = (packetRule) => {
        const { enableBuyPacket, latestDevice } = this.state
        if(CommonUtils.isEmpty(latestDevice)) return

        if (!packetRule) {
            Toast.fail('请选择游戏套餐')
            return;
        }

        if(!enableBuyPacket) {
            Toast.info('购买中')
            return;
        }

        if(this.canPayUsingBalance(packetRule)) {
            alert('确认要使用余额付款?', packetRule.name, [
                { text: '取消', onPress: () => {} },
                { text: '确认', onPress: () => {
                    this.doBuyPacket(packetRule)
                }},
              ]
            )
            return
        } 

        let exchangeGameMinutes = this.calExchangeGameMinutes()
        if(exchangeGameMinutes > 0) {
            alert(`使用余额兑换时间?`, `${exchangeGameMinutes} 分钟`, [
                { text: '取消', onPress: () => {
                    this.doBuyPacket(packetRule)
                }},
                { text: '确认', onPress: () => {
                    this.doExchangeBalance()
                }},
              ]
            )
            return
        }
        
        this.doBuyPacket(packetRule)
    }

    doBuyPacket = (packetRule) => {
        const { latestDevice } = this.state
        let self = this
        this.setState({
            enableBuyPacket: false
        })
        Toast.info('支付跳转中')
        DataFetcher.buyPacket(
            {
                gamePacket: packetRule.id,
                deviceId: latestDevice
            }, 
            (resp) => {
                CommonUtils.invokeWechatPay(resp.data, () => {
                    Toast.info('设备启动中！若无响应，可使用其它设备！', 5)
                    self.loadInitData()
                })
            },
            () => {
                this.setState({
                    enableBuyPacket: true
                })
            }
        )
    }

    doExchangeBalance = () => {
        const { latestDevice } = this.state
        let self = this
        this.setState({
            enableBuyPacket: false
        })
        Toast.info('兑换跳转中')
        DataFetcher.exchageBalance(
            {
                deviceId: latestDevice
            }, {
                success: (resp) => {
                    Toast.info('设备启动中！若无响应，可使用其它设备！', 5)
                    self.loadInitData()
                },
                completed: () => {
                    this.setState({
                        enableBuyPacket: true
                    })
                }
            }
        )
    }

    handleRecharge = (rechargeRule) => {
        const { enableRecharge, latestDevice } = this.state

        if(!enableRecharge) {
            Toast.info('充值中')
            return
        }

        let self = this
        this.setState({
            enableRecharge: false
        })
        Toast.info('支付跳转中')
        DataFetcher.recharge({
            rechargeRule,
            deviceId: latestDevice
        }, (resp) => {
            CommonUtils.invokeWechatPay(resp.data, () => {
                Toast.info('充值成功，去购买游戏套餐吧！')
                setTimeout(() => {
                    self.loadInitData()
                }, 2000)
            })
        }, () => {
            this.setState({
                enableRecharge: true
            })
        })

    }

    generateHeaderView() {
        const { latestDevice, userProfile, enableContinuing, brandInfo } = this.state;
        let description = brandInfo&&CommonUtils.isNotEmpty(brandInfo.brandName)?brandInfo.brandName:Constants.Strings.APP_NAME
        if(userProfile.latestConsumedSiteName) {
            description = userProfile.latestConsumedSiteName
            if(userProfile.latestConsumedDeviceType) {
                description += `  ${CommonUtils.resolveDictText(userProfile.latestConsumedDeviceType, this.state.deviceTypes, 'code', 'name')}`
            }
        }

        let data = {
            deviceId: latestDevice,
            avatar: userProfile.avatar,
            nickName: userProfile.nickName,
            gameMinutes: userProfile.gameMinutes,
            enableContinuing,
            description,
        }
        return <HeaderView handleContinuing={this.handleContinuing} data={data}/>
    }

    generateProfileView() {
        const { userProfile } = this.state;
        let data = []
        data.push({label: '剩余时间', value: CommonUtils.readableGameMinutes(userProfile.gameMinutes)})
        data.push({label: '账户余额', value: userProfile.balance})
        data.push({label: '游戏积分', value: userProfile.point})
        return <ProfileView data={data}/>
    }

    generateRechargeView() {
        const { latestDevice, rechargeRules } = this.state

        if(CommonUtils.isEmpty(latestDevice)) {
            return
        }

        if(!rechargeRules || !rechargeRules.length) {
            return
        }

        return <RechargeView handleRecharge={this.handleRecharge} data={rechargeRules}/>
    }

    generatePacketView() {
        const {latestDevice, packetRules, userProfile} = this.state;
        if(CommonUtils.isEmpty(latestDevice)) {
            return (
                <div className='scan-tip'>
                    请扫描屏幕上的二维码来启动设备！
                </div>
            )
        }

        let data = {
            fresher: userProfile.fresher,
            rules: packetRules
        }

        return <PacketView handleBuyPacket={this.handleBuyPacket} data={data}/>
    }

    generateDeviceView() {
        const { deviceInfo } = this.state
        if(!deviceInfo || !deviceInfo.deviceId) {
            return
        }

        let deviceName = CommonUtils.isEmpty(deviceInfo.deviceName) ? deviceInfo.deviceId : deviceInfo.deviceName
        return (
            <div className='section-device'>
                <div className='name word-ellipsis'>
                    <i className='iconfont icon-diannao'></i>
                    &nbsp;&nbsp;
                    <span>{deviceName}</span>
                </div>
            </div>
        )
    }

    doRenderView() {
        return (
            <div className="page-user">
                {this.generateHeaderView()}
                <Blank/>
                {this.generateProfileView()}
                <Blank/>
                {this.generateRechargeView()}
                {this.generatePacketView()}
                {this.generateDeviceView()}
            </div>
        )
    }

    render() {
        const {status} = this.state;

        if(status === 'loading') {
            return <LoadingPlaceholder/>;
        } else if (status === 'noauth') {
            return <TipPlaceholder firstTip={Constants.Strings.APP_NAME} secondTip={'请重新扫码'}/>;
        } else {
            return this.doRenderView()
        }
    }
}

export default createForm()(User);


// WEBPACK FOOTER //
// ./src/modules/User.js